<script setup lang="ts">
import type { V1GetOptions } from "@gasparigit/omnia-sdk";
import Magazine from "~/components/icons/Magazine.vue";
import { processError } from "~/lib/utils/errors";
import { defineSeo } from "~/lib/utils/seo";

const rivistaId = useParamId();

const omniaSdk = useOmniaSdk();

const page = usePage();

const { data, error } = await useAsyncData(`rivista-${rivistaId}`, async () => {
  try {
    return await omniaSdk.v1.riviste.riviste.get(rivistaId);
  } catch (error) {
    processError(error);
  }
});

if (error.value) processError(error.value);

const options = ref<V1GetOptions>({ order_mode: "desc" });

const { data: numeriRivista, refresh } = useAsyncData(
  `rivista-${rivistaId}-numeri`,
  async () => {
    try {
      return await omniaSdk.v1.riviste.numeri.list(
        rivistaId,
        { pagination: "classic", page: page.value },
        options.value,
      );
    } catch (error) {
      processError(error);
    }
  },
  {
    watch: [options.value],
  },
);

defineSeo(data.value);
</script>

<template>
  <FrontBreadcrumHero
    :breadcrumbs="[
      { title: 'Riviste', href: '/riviste' },
      { title: data?.title },
    ]"
    :title="data?.title"
    :icon="Magazine"
  />

  <div class="main-content">
    <FrontContentsList
      v-model:data="numeriRivista"
      v-model:page="page"
      title="Numeri"
      :icon="Magazine"
      :link-config="{ rivista: data }"
      @update:page="refresh()"
    >
      <template #side>
        <FrontRadioGroupCard v-model="options.order_mode" base-key="order" />
      </template>
    </FrontContentsList>
  </div>

  <AdminLinkToAdmin :config="{ rivista: data }" />
</template>
